// extracted by mini-css-extract-plugin
export default {"prefix":"Signup_prefix__mNnLL","skipBtn":"Signup_skipBtn__-5EWr"};